import { ComponentController } from 'Huurwoningen/Helper/Stimulus/ComponentController';
import { searchFiltersControllerFactory } from 'Shared/Component/SearchFilters/SearchFiltersControllerFactory';
import { isDesktop, watchViewport } from 'Shared/Helper/ViewPort/ViewPort';
import { findOne } from 'Shared/Helper/Dom/Dom';

const NAME = 'search-filters';

const SharedSearchFiltersController = searchFiltersControllerFactory({
    'componentController': ComponentController,
});

class SearchFiltersController extends SharedSearchFiltersController {
    connect () {
        super.connect();

        watchViewport(() => {
            moveSearchFilters();
        });

        this.moveSearchFilters();

        window.moveSearchFilters = this.moveSearchFilters.bind(this);
    }

    moveSearchFilters () {
        if (!findOne('.page--fixed-search-filters')) {
            return;
        }

        const pageFilters = findOne('.page__search-filters');
        const modalBody = findOne('.modal--search-filters .modal__body');

        if (isDesktop()) {
            if (this.element.parentNode === modalBody) {
                pageFilters.appendChild(this.element);
                this.element.classList.add('search-filters--fixed');
            }
        } else {
            if (this.element.parentNode === pageFilters) {
                modalBody.appendChild(this.element);
                this.element.classList.remove('search-filters--fixed');
            }
        }
    }
}

export default {
    'name': NAME,
    'controller': SearchFiltersController,
};
